export const emojiDictionary = {
  "💌": "Love Letter",
  "🕳️": "Hole",
  "💣": "Bomb",
  "🛀": "Person Taking Bath",
  "🛌": "Person in Bed",
  "🔪": "Kitchen Knife",
  "🏺": "Amphora",
  "️🗺️": "World Map",
  "🧭": "Compass",
  "🧱": "Brick",
  "💈": "Barber Pole",
  "🦽": "Manual Wheelchair",
  "🦼": "Motorized Wheelchair",
  "🛢️": "Oil Drum",
  "🛎️": "Bellhop Bell",
  "🧳": "Luggage",
  "⌛": "Hourglass Done",
  "⏳": "Hourglass Not Done",
  "⌚": "Watch",
  "⏰": "Alarm Clock",
  "⏱️": "Stopwatch",
  "⏲️": "Timer Clock",
  "🕰️": "Mantelpiece Clock",
  "🌡️": "Thermometer",
  "⛱️": "Umbrella on Ground",
  "🧨": "Firecracker",
  "🎈": "Balloon",
  "🎉": "Party Popper",
  "🎊": "Confetti Ball",
  "🎎": "Japanese Dolls",
  "🎏": "Carp Streamer",
  "🎐": "Wind Chime",
  "🧧": "Red Envelope",
  "🎀": "Ribbon",
  "🎁": "Wrapped Gift",
  "🤿": "Diving Mask",
  "🪀": "Yo-Yo",
  "🪁": "Kite",
  "🔮": "Crystal Ball",
  "🧿": "Nazar Amulet",
  "🕹️": "Joystick",
  "🧸": "Teddy Bear",
  "☎️": "Telephone",
  "📞": "Telephone Receiver",
  "📟": "Pager",
};
